export class StorageElementType {
    name: string;
    type: string | null;
    constructor(name: string, type: string | null) {
        this.name = name;
        this.type = type;
    }
}